import React, {Component} from 'react'
import LazyLoad from 'react-lazyload'

class LazyLoadComponent extends Component {

    constructor(props) {
        super(props)
    }

    placeHolder() {
        return (
            <div className={"lazy-load-placeholder"}></div>
        )
    }

    firstSource() {
        if (this.props.imageUrl) {
            return <source srcSet={this.props.imageUrl} media="(min-width: 1024px)"/>
        }
        else if (this.props.defaultPicture) {
            return <source srcSet={this.props.defaultPicture} media="(min-width: 1024px)"/>
        }
    }

    secondSource() {
        if (this.props.tabletUrl) {
            return <source srcSet={this.props.tabletUrl} media="(min-width: 768px) and (max-width: 1023px)"/>
        }
    }

    thirdSource() {
        if (this.props.mobileUrl) {
            return <source srcSet={this.props.mobileUrl} media="(min-width: 1px) and (max-width: 767px)"/>
        }
    }

    render() {
        const {imageUrl, defaultPicture, alt, classname} = this.props

        return (
            <LazyLoad offset={[200, 200]} placeholder={this.placeHolder()}>
                <picture>
                    {this.firstSource()}
                    {this.secondSource()}
                    {this.thirdSource()}
                    {imageUrl && <img src={imageUrl} alt={alt} className={classname} loading="lazy" />}
                    {!imageUrl && defaultPicture && <img src={defaultPicture} alt={alt} className={classname} loading="lazy"/>}
                </picture>
            </LazyLoad>
        )
    }

}

export default (LazyLoadComponent)



// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/LazyLoadComponent.js